import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { INFO } from '../../constants/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      padding: theme.spacing(2),
      '& > :nth-child(1)': {
        height: 'auto !important',
        flexShrink: 0,
      },
      '& > :nth-child(2)': {
        height: 'auto !important',
        overflow: 'auto',
        padding: theme.spacing(1, 0),
      },
    },
    bubble: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: INFO,
      overflow: 'hidden',
      borderRadius: 12,
      '& > :not(:nth-child(1))': {
        padding: theme.spacing(1),
      },
    },
    message: {
      color: 'white',
    },
    time: {
      fontSize: 12,
      color: '#87888A',
      alignSelf: 'end',
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(0.5),
      },
    },
  }),
);

export default useStyles;
